export const IMG_URl = "https://restaurantapi.twhmenu.com/storage/";
// export const IMG_URl = "https://testapi.twhmenu.com/storage/";
// export const IMG_URl = "https://testapi.twhtest.com/storage/";
// export const IMG_URl = "http://127.0.0.1:8000/storage/";
